module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("cg2eR"))).then(() => parcelRequire('7N5ge'));